import React, { useLayoutEffect, useRef } from 'react';
import styled from 'styled-components';

import { DescriptionType } from '@/modules/Product/components/Main/components/Tabs/Tabs';
import { colors } from '@/constants/theme';

type Props = {
  data: DescriptionType[];
  setHeight?: (height: number) => void;
};

function Description({ data, setHeight }: Props) {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (ref.current) {
      setHeight?.(ref.current.scrollHeight);
    }
  });

  return (
    <Component ref={ref}>
      <Content>
        {data.map((content, index) => (
          <Content
            key={index}
            dangerouslySetInnerHTML={{ __html: content.content }}
          />
        ))}
      </Content>
    </Component>
  );
}

export default Description;

const Component = styled.div`
  & > *:first-child {
    margin-top: 0;
  }
`;
const Content = styled.div`
  padding-bottom: 15px;
  & > p,
  ul {
    margin-top: 20px;
  }
  & > ul li {
    list-style: initial;
    margin-left: 15px;
  }

  & > *:first-child {
    margin-top: 0;
  }
  & > ul a {
    color: ${colors.primary};
  }
`;
